// frontend/src/App.jsx

import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from './context/AuthContext'; 
import LoginView from './views/LoginView';       
import Header from './components/Header';
import AddPrinterView from './views/AddPrinterView';
import MaintenanceView from './views/MaintenanceView'; 
import PrinterList from './views/PrinterList';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });
    console.error("Uncaught Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', color: '#b91c1c', fontFamily: 'sans-serif', maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{borderBottom: '2px solid #fca5a5', paddingBottom: '10px'}}>?? Application Error</h2>
          <div style={{ background: '#fef2f2', padding: '20px', borderRadius: '8px', border: '1px solid #fca5a5', overflowX: 'auto' }}>
            <strong style={{display:'block', marginBottom:'10px'}}>
                {this.state.error ? this.state.error.toString() : "Unknown Error"}
            </strong>
            <details style={{ whiteSpace: 'pre-wrap', fontSize: '0.85rem', color: '#7f1d1d' }}>
              <summary style={{cursor:'pointer', marginBottom:'10px'}}>View Stack Trace</summary>
              {/* ?? FIX: Check if errorInfo exists before reading it */}
              {this.state.errorInfo ? this.state.errorInfo.componentStack : "Stack trace pending..."}
            </details>
          </div>
          <button onClick={() => window.location.href = '/'} style={{ marginTop: 20, padding: '10px 20px', backgroundColor: '#0d9488', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
             Return to Dashboard
          </button>
        </div>
      );
    }
    return this.props.children; 
  }
}

function AppContent() {
  const { user, loading } = useAuth();
  
  // Read URL immediately
  const urlParams = new URLSearchParams(window.location.search);
  const qrKey = urlParams.get('key');

  const [view, setView] = useState('list'); 

  if (loading) return <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh'}}>Loading...</div>;

  if (!user) return <LoginView />;

  return (
    <div className="App">
      <Header user={user} /> 
      <main>
        {qrKey ? (
          <MaintenanceView qrKey={qrKey} />
        ) : view === 'add' ? (
          <div className="container" style={{ maxWidth: '600px' }}>
             <button className="secondary" onClick={() => setView('list')} style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px', width: 'auto', padding: '8px 16px' }}>
                <ArrowLeft size={20} /> Back to Fleet
             </button>
             <AddPrinterView />
          </div>
        ) : (
          <PrinterList onAddClick={() => setView('add')} />
        )}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AppContent />
    </ErrorBoundary>
  );
}